import { ContentTypeEnum, FeatureNameEnum } from 'constants-content';
import {
  FeatureDefinition,
  ContentTypeRequirementEnum,
} from '../../FeatureDefinition';

export const workOrderFeatureDefinition: FeatureDefinition = {
  name: FeatureNameEnum.WorkOrder,
  description: 'Submit and view Service Requests',
  superUserOnly: false,
  friendlyName: 'Work Order',
  requiresInteraction: true,
  properties: {
    ServiceRequest: {
      friendlyName: 'Service request',
      description: 'Information about the service request',
      type: 'ServiceRequestType',
      editable: true,
      isArray: false,
      forDisplay: true,
      showControl: true,
    },
  },
  interactionData: {
    ServiceRequest: {
      friendlyName: 'Service request',
      description: 'Information about the service request',
      type: 'ServiceRequestType',
      editable: true,
      isArray: false,
      forDisplay: true,
      showControl: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    Schedule: {
      friendlyName: 'Service request schedule',
      description: 'Information about the service request schedule',
      type: 'ServiceRequestScheduleType',
      editable: true,
      isArray: false,
      forDisplay: true,
      showControl: true,
      validators: [],
    },
  },
  contentTypeRequirements: [
    {
      type: ContentTypeEnum.VisitorManagement,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.Static,
      requirement: ContentTypeRequirementEnum.Optional,
    },
    {
      type: ContentTypeEnum.Notice,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.Content,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.ScheduledContent,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.ScheduledNotice,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.Promotion,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.Perk,
      requirement: ContentTypeRequirementEnum.Forbidden,
    },
    {
      type: ContentTypeEnum.WorkOrder,
      requirement: ContentTypeRequirementEnum.Required,
    },
  ],
};
